import { connect } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';
import { openRoomPopupAction } from 'checkout/store/domains/room-popup/actions';
import { updatePackageId } from 'checkout/store/actions/package';
import { resetScrollPositionAction } from 'checkout/store/actions/view';
import { getScrollPosition } from 'checkout/store/selectors/view';
import { getIsPayPath } from 'checkout/store/selectors/router';
import {
  getExtraRoomsOffers,
  getExtraRoomsOriginalPackageId,
} from 'checkout/store/selectors/extra-rooms';
import {
  getPackageId,
  getTouristsCount,
} from 'checkout/store/selectors/package';
import { ExtraRooms } from './ExtraRooms';

const mapStateToProps = (state) => ({
  touristsCount: getTouristsCount(state),
  offers: getExtraRoomsOffers(state),
  currentPackageId: getPackageId(state),
  originalPackageId: getExtraRoomsOriginalPackageId(state),
  isMobile: getIsMobile(state),
  prevScrollPosition: getScrollPosition(state),
  isServicesPath: getIsPayPath(state),
});

const mapDispatchToProps = {
  onClick: updatePackageId,
  aboutRoomOnClick: openRoomPopupAction,
  resetScrollPosition: resetScrollPositionAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExtraRooms);
